import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '@auth/AuthContext';
import { config } from '@config/index';
import { Footer } from '@components/Footer';

/**
 * Layout for public routes: header with logo + nav links, footer, no sidebar.
 */
export function PublicLayout() {
  const { isAuthenticated, user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch {
      // silently handle sign-out errors
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2 font-semibold text-lg">
            <span className="text-primary">MedRender</span>
          </Link>
          <nav className="flex items-center gap-4">
            <Link
              to="/features"
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              Features
            </Link>
            {isAuthenticated ? (
              <>
                <span className="text-sm font-medium text-foreground">
                  {user?.name || user?.email || 'User'}
                </span>
                <button
                  onClick={handleSignOut}
                  className="inline-flex h-9 items-center justify-center rounded-md border border-input bg-background px-4 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground"
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                >
                  Log in
                </Link>
                {config.signupEnabled && (
                  <Link
                    to="/signup"
                    className="inline-flex h-9 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90"
                  >
                    Sign up
                  </Link>
                )}
              </>
            )}
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
